/* ==========================================================================
   ButtonRxjs > Template
   ========================================================================== */

/* Import modules */
const { html } = require('common-tags');

const ViewHelpers = require('@bluekiri/alexandria/core/ViewHelpers');

const { prepareDataConfig } = require('@bluekiri/alexandria/helpers/dataHelpers');
const { sanitizeSingleQuote } = require('@bluekiri/alexandria/helpers/sanitize');

const configuration = require('./client/js/config');

/**
 * ButtonRxjs template
 * @param {object} data Object containing the data model for this component.
 * @returns {string} Html
 */
module.exports = function Template(data = {}, context = {}) {
    /* Data */
    const { config = {}, content = '', icon, type = 'button', title = '', disabled = false, hasLoader = true } = data;
    const { styles = [] } = config;
    const { dataType } = prepareDataConfig(config.data);

    /* View Helpers */
    const { icon: renderIcon } = ViewHelpers(context);

    /* Return */
    return html(`
        <button class='${['button-rxjs', ...styles].join(' ').trim('')}'
            type='${type}'
            ${title ? `title='${title}'` : ''}
            data-component='${configuration().component}'
            ${dataType ? `data-type='${dataType}'` : ''}
            data-config='${JSON.stringify({
                ...config,
                disabled,
                content: sanitizeSingleQuote(content),
                hasLoader
            })}'>
            ${icon ? `${renderIcon(icon)}` : ''}
            ${content ? `<span data-button-content=''>${content}</span>` : ''}
        </button>
    `);
};
